import appConfig from '../../../functions/config.json';

export const GoogleMapApiConfig = appConfig.googleApiKeys.web;
